
import { useState, useEffect } from 'react';

export default function FloatingIcons() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
      {/* Floating dental icons */}
      <div className="absolute top-20 left-10 animate-bounce opacity-20">
        <i className="ri-tooth-line text-[#D4AF37] text-2xl"></i>
      </div>
      
      <div className="absolute top-40 right-20 animate-pulse opacity-15">
        <i className="ri-heart-pulse-line text-[#D4AF37] text-xl"></i>
      </div>
      
      <div className="absolute bottom-40 left-20 animate-bounce opacity-20" style={{ animationDelay: '0.5s' }}>
        <i className="ri-shield-check-line text-[#D4AF37] text-lg"></i>
      </div>
      
      <div className="absolute top-60 right-40 animate-pulse opacity-15" style={{ animationDelay: '1s' }}>
        <i className="ri-star-line text-[#D4AF37] text-xl"></i>
      </div>
      
      <div className="absolute bottom-60 right-10 animate-bounce opacity-20" style={{ animationDelay: '1.5s' }}>
        <i className="ri-medal-line text-[#D4AF37] text-lg"></i>
      </div>
      
      <div className="absolute top-80 left-40 animate-pulse opacity-15" style={{ animationDelay: '2s' }}>
        <i className="ri-time-line text-[#D4AF37] text-xl"></i>
      </div>
    </div>
  );
}
